import m from 'mithril'

export default {
    view() {
        return m("div.k-portlet",
            [
                m("div.k-portlet__head",
                    m("div.k-portlet__head-label",
                        m("h3.k-portlet__head-title",
                            [
                                "Tutorials"
                            ]
                        )
                    )
                ),
                m("div.k-portlet__body",
                    m("div.k-list.k-list--badge",
                        [
                            m("a[href='#'].k-list__item",
                                [
                                    m("span.k-list__badge.k-list__badge--success"),
                                    m("span.k-list__icon",
                                        m("i.flaticon2-chronometer.k-font-success")
                                    ),
                                    m("span.k-list__text", "Create new questions for your project")
                                ]
                            ),

                            m("a[href='#'].k-list__item",
                                [
                                    m("span.k-list__badge.k-list__badge--success"),
                                    m("span.k-list__icon",
                                        m("i.flaticon2-chronometer.k-font-success")
                                    ),
                                    m("span.k-list__text", "Adding data from other systems")
                                ]
                            ),

                            m("a[href='#'].k-list__item",
                                [
                                    m("span.k-list__badge.k-list__badge--success"),
                                    m("span.k-list__icon",
                                        m("i.flaticon2-chronometer.k-font-success")
                                    ),
                                    m("span.k-list__text", "Sending surveys to users")
                                ]
                            )
                        ]
                    )
                )
            ]
        )
    }
}